import React from "react";

const CompanyOverview = () => {
  return (
    <div className="text-center py-16 bg-gray-100">
      {/* 会社概要 タイトル */}
      <div className="mb-16">
        <h1 className="text-3xl font-bold text-gray-800">会社概要</h1>
        <img src="/images/image4.png" alt="装飾ライン" className="mx-auto my-2 w-32" />
      </div>

      {/* 会社名 */}
      <div className="max-w-xl mx-auto">
        <h2 className="text-4xl font-bold text-gray-800 mt-6">アプロ山梨株式会社</h2>
        <img src="/images/image5.png" alt="装飾ライン" className="mx-auto my-2 w-auto px-8" />
      </div>
      {/* 会社情報 */}
      <div className="max-w-xl mx-auto">
        <div className="mt-8 text-gray-700 text-sm space-y-6 px-8 text-left">
          <div>
            <p className="font-semibold text-xl pb-2">設立</p>
            <p className="border-b border-gray-500 w-full">令和６年５月３１日</p>
          </div>
          <div>
            <p className="font-semibold text-xl pb-2">所在地</p>
            <p className="border-b border-gray-500 w-full">山梨県富士吉田市下吉田八丁目２番４０号</p>
          </div>
          <div>
            <p className="font-semibold text-xl pb-2">資本金</p>
            <p className="border-b border-gray-500 w-full">１０００万円</p>
          </div>
          <div>
            <p className="font-semibold text-xl pb-2">事業内容</p>
            <p>
              １、不動産の売買、交換、賃貸借及びその仲介並びに、所有、管理<br />（グループ会社にて対応）<br />
              ２、旅館・ホテル、簡易宿所及び民泊物件の保有、運営、管理<br />
              ３、不動産に関するコンサルティング<br />
              <p className="border-b border-gray-500 w-full">４、前各号に附帯する一切の業務</p>
            </p>
          </div>
          <div>
            <p className="font-semibold text-xl pb-2">役員</p>
            <p>代表取締役　池田孝一</p>
            <p className="border-b border-gray-500 w-full">代表取締役　宇佐美勝宏</p>
          </div>
        </div>
      </div>

      {/* Googleマップの埋め込み */}
      <div className="mt-8 flex justify-center">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d812.0926728505204!2d138.81036388551718!3d35.49511114411168!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6019670048416769%3A0xb1016b5fca9c1ca8!2z44Ki44OX44Ot5bGx5qKo5qCq5byP5Lya56S-!5e0!3m2!1sja!2sjp!4v1738830360537!5m2!1sja!2sjp"
          width="600"
          height="450"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default CompanyOverview;
